import { styled } from "@mui/material/styles";

export const CustomSection = styled("div")(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2, 3),
  "&:first-of-type": {
    borderTop: "none",
  },
}));
